import React, { useState } from 'react';
import { Icons } from '@/assets';
import { Map } from '@/components/Search';
import LoadingV2 from '@/components/Loading';
import SavedSearchesV2 from './SavedSearchesV2';
import { Icon } from '@/components/Icon';
import { SearchContainerCard } from './SearchContainerCard';
import IconButton from '@/ctComponents/IconButton';
import { SavedSearchesHistoryModal } from './SavedSearchesHistoryModal';
import { useStickyDiv } from '@/hooks/useStickyDiv';
import LocationOffersModal from './LocationOffersModal';
import { noScroll } from '@/actions/Helper';

export const SearchResultMapView = (props) => {
  const {
    loading,
    DATA,
    openReserve,
    savedSearches,
    savedSearchesLoading,
    refetchSavesSearches,
    setReserveInformation,
    reservedItem,
  } = props;

  const [openSavedSearchesModal, setOpenSavedSearchesModal] = useState(false);
  const [savedList, setSavedList] = useState([]);
  const [isRightModalOpen, setIsRightModalOpen] = useState(false);
  const [selectedLocationData, setSelectedLocationData] = useState(null);

  const handleAddToFavList = (item) => {
    setSavedList([...savedList, item]);
  };

  const handleMarkerClick = async (item) => {
    if (item) {
      noScroll();
      setSelectedLocationData(item.address);
      setIsRightModalOpen(true);
    }
  };

  const handleCloseRightModal = () => {
    setIsRightModalOpen(false);
    setSelectedLocationData(null);
  };

  const { divRef } = useStickyDiv({
    headerHeight: 64,
  });

  return (
    <>
      <div className="col-span-1 2xl:col-span-1 lg:h-full flex flex-col ">
        <div className="lg:h-full  min-w-full overflow-hidden rounded-xl  border border-solid ">
          <div className=" pb-4 px-2 flex-1 flex h-full flex-col ">
            <div className="flex justify-between items-center shrink-0 px-2">
              <h2 className="text-lg text-primary-text-secondary font-bold flex items-center  gap-2 m-0 py-4">
                <Icon src={Icons.containerIcon} width={24} height={24} />
                Offer List
              </h2>
            </div>
            <hr className="mb-4 w-full mt-0 border-t border-solid shrink-0" />
            <div className="flex-1 overflow-y-auto pb-4 pt-0.5 px-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 2xl:grid-cols-2 gap-4 ">
              {!(loading && DATA.length === 0) &&
                DATA.map((containerItem) => (
                  <SearchContainerCard
                    key={containerItem.id}
                    containerItem={containerItem}
                    openReserve={openReserve}
                    handleAddToFavList={handleAddToFavList}
                    savedList={savedList}
                    setReserveInformation={setReserveInformation}
                    reservedItem={reservedItem}
                  />
                ))}

              {loading && (DATA.length === 0 || (DATA && DATA.length > 0)) && (
                <div className="flex justify-center py-4 2xl:col-span-2 sm:col-span-2 col-span-1 lg:col-span-1">
                  <LoadingV2 />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        ref={divRef}
        className={`col-span-2 h-fit 2xl:col-span-1 transition-transform duration-200 ease-out `}>
        <div
          className="border border-solid pb-4 px-4 rounded-xl shrink-0 "
          style={{
            height: 292,
          }}>
          <div className="flex justify-between items-center">
            <h2 className="text-primary-text-secondary text-lg m-0 font-bold flex items-center gap-2 py-4">
              <Icon src={Icons.liveMap} width={24} height={24} />
              Live Map
            </h2>
          </div>
          <hr className="mb-4 mt-0  border-t border-solid" />
          <div>
            <Map
              DATA={DATA}
              smart={false}
              className="h-244"
              onMarkerClick={handleMarkerClick}
            />
          </div>
        </div>
        <div className="border border-solid pb-4 px-4 rounded-xl mt-4 flex flex-col ">
          <div className="flex justify-between items-center shrink-0">
            <h2 className="text-primary-text-secondary text-lg font-bold flex items-center  gap-2 m-0 py-4 ">
              <Icon src={Icons.searchList} width={24} height={24} />
              Empty Container Watchlist
            </h2>
            <IconButton
              onClick={() => {
                setOpenSavedSearchesModal(true);
              }}
              text={'History'}
              icon="timeFile"
              color={'#131617'}
              style={{
                height: 40,
                borderRadius: 4,
              }}
              size={'big'}
            />
          </div>
          <hr className="mb-4 mt-0  border-t border-solid w-full" />
          <div
            className="flex-1 overflow-y-auto"
            style={{
              maxHeight: 'calc(100vh - 496px)',
            }}>
            <SavedSearchesV2
              refetchSavesSearches={refetchSavesSearches}
              loading={savedSearchesLoading}
              savedSearches={savedSearches}
            />
          </div>
        </div>
      </div>

      <SavedSearchesHistoryModal
        show={openSavedSearchesModal}
        setShow={setOpenSavedSearchesModal}
        data={savedSearches}
      />

      {isRightModalOpen && (
        <LocationOffersModal
          isOpen={isRightModalOpen}
          onClose={handleCloseRightModal}
          locationData={selectedLocationData}
          openReserve={openReserve}
          handleAddToFavList={handleAddToFavList}
          savedList={savedList}
          setReserveInformation={setReserveInformation}
          reservedItem={reservedItem}
        />
      )}
    </>
  );
};

export default SearchResultMapView;
